import React, { useEffect, useState, useRef } from "react";

const Counter = ({ start = 1, end, step = 1, duration = 2000, suffix = "" }) => {
    const [count, setCount] = useState(start);
    const counterRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    animateCounter(start, end, step, duration);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.5 } // Trigger when 50% visible
        );

        if (counterRef.current) {
            observer.observe(counterRef.current);
        }

        return () => observer.disconnect();
    }, [start, end, step, duration]);

    const animateCounter = (start, end, step, duration) => {
        let current = start;
        const range = end - start;
        const increment = step || range / (duration / 16); // Calculate step size
        const startTime = performance.now();

        const updateCounter = (timestamp) => {
            const elapsedTime = timestamp - startTime;
            if (elapsedTime < duration) {
                current = Math.min(end, start + (range * elapsedTime) / duration);
                setCount(Math.floor(current));
                requestAnimationFrame(updateCounter);
            } else {
                setCount(end); // Ensure the final value is set
            }
        };

        requestAnimationFrame(updateCounter);
    };

    return (
       
            <div className="qodef-m-digit-wrapper" ref={counterRef}>
                <span className="qodef-m-digit">{count + suffix}</span>
            </div>
       
    );
};
export default Counter;
